var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/\xEB\x82\xB4\xEB\xB3\xB4\xEB\x82\xB4\xEA\xB8\xB0\xEB\x82\xB4\xEC\x97\xAD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.97368 26.3158C1.44737 26.3158 0.986842 26.1184 0.592105 25.7237C0.197368 25.3289 0 24.8684 0 24.3421V1.97368C0 1.44737 0.197368 0.986842 0.592105 0.592105C0.986842 0.197368 1.44737 0 1.97368 0H13.1579L21.0526 7.89474V16.7763H19.0789V9.21053H11.8421V1.97368H1.97368V24.3421H15.4605V26.3158H1.97368ZM23.6184 26.3487L19.4079 22.1382V26.25H17.4342V18.75H24.9342V20.7237H20.7895L25 24.9342L23.6184 26.3487Z",
    fill: "#002868"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavExport);
export default __webpack_public_path__ + "static/media/nav-export.bb2adc240e48a6299cb9d678a08ff837.svg";
export { ForwardRef as ReactComponent };